// Release notes are authored in frontend/RELEASE_NOTES.md and bundled with the
// build (Vite `?raw` import), so every deploy publishes the latest notes to all
// slots — no upload step. This module is the single source for the markdown and
// the "unseen updates" dot shared by the What's New page and the header menu.
import raw from '../../RELEASE_NOTES.md?raw';

export const releaseNotesMarkdown = raw;

// The table is reverse-chronological, so the first YYYY-MM-DD in the file is the newest release date.
const firstDate = raw.match(/\d{4}-\d{2}-\d{2}/);
export const latestReleaseDate = firstDate ? firstDate[0] : '';

const SEEN_KEY = 'whatsNewSeenDate';

export function hasUnseenReleases(): boolean {
  if (!latestReleaseDate) return false;
  try {
    return (localStorage.getItem(SEEN_KEY) ?? '') < latestReleaseDate;
  } catch {
    return false;
  }
}

export function markReleasesSeen(): void {
  if (!latestReleaseDate) return;
  try {
    localStorage.setItem(SEEN_KEY, latestReleaseDate);
  } catch {
  }
}
